var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0", attrs: { width: "100%", outlined: "" } },
    [
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c("v-data-table", {
            staticStyle: { width: "100%" },
            attrs: {
              "fixed-header": "",
              items: _vm.configs,
              headers: _vm.headers,
              "hide-default-footer": "",
              "disable-pagination": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.group",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-card-text",
                      { staticClass: "orange--text subtitle-2 ma-0 pa-0" },
                      [_vm._v(_vm._s(item.group))]
                    ),
                  ]
                },
              },
              {
                key: "item.tag",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "green--text subtitle-2",
                                          attrs: { outlined: "", small: "" },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.getTagText(item.tag)) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v(_vm._s(item.tag))])]
                    ),
                  ]
                },
              },
              {
                key: "item.meta.uid",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-card-text",
                      { staticClass: "blue--text subtitle-2 ma-0 pa-0" },
                      [_vm._v(_vm._s(_vm.getOwner(item)))]
                    ),
                  ]
                },
              },
              {
                key: "item.meta.updated",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatDate")(_vm.getUpdated(item))) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", "max-width": "50%" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { icon: "", color: "orange" },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("v-icon", { attrs: { size: "22" } }, [
                                        _vm._v("mdi-information"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              item.info != undefined && item.info.length != 0
                                ? item.info
                                : "no info"
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }